/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'qs';

const BASE_API_SOLUTIONS_URL = process.env.VUE_APP_BASEAPINUFIURL;

let configuration = {};

const configure =  () => {
  let config = {};
  axios.get(`${BASE_API_SOLUTIONS_URL}/solution/config/developer-onboarding/local`).then(response => {
    if (response.status === 200) {

      config = response.data;

      config.config_Api_Manager = {
        headers: {
          authorization: config.authApiManager
        }
      };

      config.config_Api_Stripe = {
        headers: {
          authorization: config.authApiStripe,
          "content-type": "application/x-www-form-urlencoded"
        }
      };
    }    
    configuration = config;    
  });  
}

configure();

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    createPaymentMethod({ commit, state }, stripeParams) {      
      return stripeParams.stripe.createPaymentMethod({
        type: 'card',
        card: stripeParams.card,
        billing_details: {
          ...stripeParams.details
        },
      });
    },
    createSource({ commit, state }, stripeParams) {
      return stripeParams.stripe.createSource(
        stripeParams.card,
        {
        type: 'card'
      });
    },
    createNuFiCustomer({ commit, state }, user) {      
      return axios.post(`${configuration.apiManagerUrl}/users?api-version=2019-12-01`, {
        properties: {
          ...user
        }
      }, configuration.config_Api_Manager);
    },
    createNuFiSubscription({ commit, state }, subscription) {
      return axios.put(`${configuration.apiManagerUrl}/subscriptions/${subscription.name}?api-version=2019-12-01`, {
        properties: {
          ownerId: `/subscriptions/48ae5a74-5338-453e-9ee9-d8e7e3dbf92b/resourceGroups/NuFi_RG/providers/Microsoft.ApiManagement/service/nufi-5338-453e-9ee9-d8e7e3dbf92b${subscription.userId}`,
          scope: "/subscriptions/48ae5a74-5338-453e-9ee9-d8e7e3dbf92b/resourceGroups/NuFi_RG/providers/Microsoft.ApiManagement/service/nufi/products/nufi",
          displayName: "NuFi2020",
          name: subscription.name
        }
      }, configuration.config_Api_Manager);
    },
    createNuFiSubscriptionSubmitted({ commit, state }, subscription) {
      return axios.put(`${configuration.apiManagerUrl}/subscriptions/${subscription.name}?api-version=2019-12-01`, {
        properties: {
          ownerId: `/subscriptions/48ae5a74-5338-453e-9ee9-d8e7e3dbf92b/resourceGroups/NuFi_RG/providers/Microsoft.ApiManagement/service/nufi-5338-453e-9ee9-d8e7e3dbf92b${subscription.userId}`,
          scope: "/subscriptions/48ae5a74-5338-453e-9ee9-d8e7e3dbf92b/resourceGroups/NuFi_RG/providers/Microsoft.ApiManagement/service/nufi/products/nufi",
          displayName: "NuFi2020",
          name: subscription.name,
          state: 'submitted'
        }
      }, configuration.config_Api_Manager);
    },
    verifyCapcha({ commit, state }, token) {
      return axios.post(`https://nufiservice029.azurewebsites.net/apiconsumer/verify/capcha`, token);
    },
    createStripeCustomer({ commit, state }, customer) {
      const data = qs.stringify(customer);
      return axios.post(`${configuration.baseApiStripeURL}/v1/customers`, data, configuration.config_Api_Stripe);
    },
    updateStripeCustomer({ commit, state }, customer) {
      const data = qs.stringify(customer);
      return axios.post(`${configuration.baseApiStripeURL}/v1/customers`, data, configuration.config_Api_Stripe);
    },
    createSolutionUser({ commit, state }, user) {
      return axios.post(`${BASE_API_SOLUTIONS_URL}/security/user/add`, user);
    },
  },
  modules: {
  }
})
